<template>
    <div class="sedna-slider">
        <div class="slide" v-for="(item, i) in items" :key="i" :class="i === activeSlide ? `active` : `inactive`">
            <h2>{{ item.title }}</h2>
            <div class="timestamp">{{ item.timestamp }}</div>
            <div class="source">{{ item.sourceTitle }}</div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Slider',
  props: {
    items: Array,
  },
  data() {
    return {
      activeSlide: 0,
      timer: null,
    }
  },
  methods: {
    randomizeSlide: function () {
      const maxNumber = this.items.length
      this.activeSlide = Math.floor(Math.random() * Math.floor(maxNumber))
    }
  },
  mounted: function() {
    let timerDelay = 3;
    const urlQuery = new URLSearchParams(window.location.search)
    if (urlQuery.get("delay") !== null) {
      timerDelay = parseFloat(urlQuery.get("delay"))
    }

    this.randomizeSlide()
    this.timer = setInterval(this.randomizeSlide, timerDelay * 1000)
  },
  beforeDestroy: function () {
    clearInterval(this.timer)
  }
}
</script>

<style>
  .sedna-slider {
      position: relative;
      width: 100%;
      height: 280px;
  }
  .slide {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      opacity: 0;
      transition: opacity .6s ease-in-out;
  }
  .slide.active {
      opacity: 1;
      transition: opacity .6s ease-in-out;
  }
  .slide .source {
      position: absolute;
      bottom: 0;
      right: 0;
      font-size: 30px;
  }
  .slide .timestamp {
      position: absolute;
      bottom: 0;
      left: 0;
      font-size: 30px;
  }
  .aretv .slide .source {
    font-size: 32px;
  }
  .aretv .timestamp {
    font-size: 32px;
  }
</style>
